import React, { useEffect, useState, useCallback } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import './UsersList.css';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import TopBar from "./TopBar";
import { Col, Container, Form, Row } from "react-bootstrap";
import { fetchPranthList } from './pranthService'; // Adjust path as needed



const ListArthikSakhas = () => {

  const handleRedirect = () => {
    navigate("/createfranchise");
  }
  const [franchises, setFranchises] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const franchisesPerPage = 15;
  const axiosPrivate = useAxiosPrivate();
  const LIST_JILLA_URL = "list-jillas?vibhag_id=1";
  const navigate = useNavigate();

  const [pranthList, setPranthList] = useState([]);
  const [vibhagList, setVibhagList] = useState([]);
  const [selectedPranthId, setSelectedPranthId] = useState("");
  const [selectedVibhagId, setSelectedVibhagId] = useState("");

  const [jillaList, setJillaList] = useState([]);
  const [selectedJillaId, setSelectedJillaId] = useState("");



  // const fetchPranthList = async () => {
  //   try {
  //     // const res = await axiosPrivate.get("list-pranths");
  //     // setPranthList(res.data);
  //     setPranthList([
  //       { id: "1", name: "ഉത്തര കേരളം" },
  //       { id: "2", name: "ദക്ഷിണ കേരളം" },
  //     ]);
  //   } catch (err) {
  //     console.error("Failed to fetch pranths", err);
  //     setPranthList([
  //       { id: "1", name: "ഉത്തര കേരളം" },
  //       { id: "2", name: "ദക്ഷിണ കേരളം" },
  //     ]);
  //   }
  // };
  // useEffect(() => {
  //   fetchPranthList();
  // }, []);

  useEffect(() => {
    const getPranths = async () => {
      const data = await fetchPranthList(); // Get data from the service
      setPranthList(data);                  // Set data to state
    };

    getPranths();
  }, []);

  const fetchVibhagList = async (pranthId) => {
    try {
      const res = await axiosPrivate.get(`list-vibhags?pranth_id=${pranthId}`);
      const data = Array.isArray(res.data) ? res.data : [];
      setVibhagList(data);
      return data;
    } catch (err) {
      console.error("Failed to fetch vibhags", err);
      setVibhagList([]);
      return [];
    }
  };


  const fetchJillaList = useCallback(async () => {
    try {
      const res = await axiosPrivate.get(`list-jillas?vibhag_id=${selectedVibhagId}`);
      const data = Array.isArray(res.data) ? res.data : [];
      setJillaList(data);
      if (data.length > 0) {
        setSelectedJillaId(data[0].jilla_id); // default selection
      } else {
        setSelectedJillaId("");
      }
    } catch (err) {
      console.error("Jilla fetch failed:", err);
      setError("Failed to load jilla list");
      setJillaList([]);
      setSelectedJillaId("");
    }
  }, [axiosPrivate, selectedVibhagId]);





  const fetchArthikSakhas = useCallback(async () => {
    if (!selectedJillaId) return;

    setLoading(true);
    setFranchises([]); // ⬅️ CLEAR OLD DATA before fetching new

    try {
      const res = await axiosPrivate.get(`list-arthik-sakhas?jilla_id=${selectedJillaId}`);
      setFranchises(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.error("Arthiksakhas fetch failed:", err);
      setError("Failed to load Arthiksakhas list");
      setFranchises([]);
    } finally {
      setLoading(false);
    }
  }, [axiosPrivate, selectedJillaId]);






  const handleViewClick = (Id) => {
    // Navigate to the GetFranchise component with franchiseId as a URL parameter
    navigate(`/Admin/listSthans/InArthikSakha/${Id}`);
  };
  const handleEditClick = (franchiseId) => {
    navigate(`/UpdateFranchise/${franchiseId}`);
  };

  const handleActiveUsersClick = (Id) => {
    navigate(`/admin/list/sthanUsersInArthikSakha/${Id}`);
  };


  useEffect(() => {
    if (selectedPranthId) {
      fetchVibhagList(selectedPranthId).then((vibhags) => {
        if (vibhags.length > 0) {
          setSelectedVibhagId(vibhags[0].vibhag_id);
        } else {
          setSelectedVibhagId("");
          setVibhagList([]);
          setSelectedJillaId("");       // ⬅️ clear jilla selection
          setJillaList([]);             // ⬅️ clear jilla list
          setFranchises([]);            // clear table
          setError("No vibhags for selected pranth");
        }

      });
    }
  }, [selectedPranthId]);


  useEffect(() => {
    if (selectedVibhagId) {
      fetchJillaList();
    }
  }, [selectedVibhagId]);

  useEffect(() => {
    if (selectedJillaId) {
      setCurrentPage(1); // Reset to page 1 when Jilla changes
      setError(null);
      setLoading(true);
      fetchArthikSakhas();
    }
  }, [selectedJillaId]);






  const indexOfLastFranchise = currentPage * franchisesPerPage;
  const indexOfFirstFranchise = indexOfLastFranchise - franchisesPerPage;
  const currentFranchise = franchises.slice(indexOfFirstFranchise, indexOfLastFranchise);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const totalPages = Math.ceil(franchises.length / franchisesPerPage);

  // if (loading) {
  //   return <div className="loading">Loading...</div>;
  // }

  // if (error) {
  //   return <div className="error">{error}</div>;
  // }

  return (
    <>
      {/* <Container> */}
      <section className="empbody">
        <div className="wrapperemp2">
          <button onClick={() => navigate(-1)} className="btn btn-secondary newviewbtn"> ← Back</button>
          {/* <button onClick={handleRedirect} type="button" className="btn btn-success ms-auto d-block top-bt">+ Create Arthiksakha</button> */}
          <h3>Arthiksakhas</h3>
          <Row className="mb-3">
            <Col md={4}>
              <Form.Label className="newformstyle">Select Pranth</Form.Label>
              <Form.Select
                className="newselectstyle"
                value={selectedPranthId}
                onChange={(e) => {
                  const pranthId = e.target.value;
                  setSelectedPranthId(pranthId);

                  if (!pranthId) {
                    // Clear vibhag, jilla, and table if no Pranth selected
                    setVibhagList([]);
                    setSelectedVibhagId("");
                    setJillaList([]);
                    setSelectedJillaId("");
                    setFranchises([]);
                  }
                }}
              >
                <option value="">-- Select Pranth --</option>
                {pranthList.map((p) => (
                  <option key={p.id} value={p.id}>
                    {p.name}
                  </option>
                ))}
              </Form.Select>

            </Col>

            <Col md={4}>
              <Form.Label className="newformstyle">Select Vibhag</Form.Label>
              <Form.Select
                className="newselectstyle"
                value={selectedVibhagId}
                onChange={(e) => {
                  const vibhagId = e.target.value;
                  setSelectedVibhagId(vibhagId);

                  if (!vibhagId) {
                    // Clear Jilla list and selection if no Vibhag selected
                    setJillaList([]);
                    setSelectedJillaId("");
                    setFranchises([]); // Optional: clear table too
                  }
                }}
                disabled={!vibhagList.length}
              >
                <option value="">-- Select Vibhag --</option>
                {Array.isArray(vibhagList) &&
                  vibhagList.map((v) => (
                    <option key={v.vibhag_id} value={v.vibhag_id}>
                      {v.vibhag_name}
                    </option>
                  ))}
              </Form.Select>

            </Col>
            <Col md={4}>
              <Form.Label className="newformstyle">Select Jilla</Form.Label>
              <Form.Select
                className="newselectstyle"
                value={selectedJillaId}
                onChange={(e) => setSelectedJillaId(e.target.value)}
                disabled={!jillaList.length}
              >
                <option value="">-- Select Jilla --</option>
                {jillaList.map((j) => (
                  <option key={j.jilla_id} value={j.jilla_id}>
                    {j.jilla_name}
                  </option>
                ))}
              </Form.Select>
            </Col>

          </Row>
          <div className="table-container">
            <table id="customers">
              <thead>
                <tr>
                  <th>Arthiksakha ID</th>
                  <th>Arthiksakha Name</th>
                  <th>Arthiksakha Name (MALAYALAM)</th>
                  <th>Jilla Name</th>
                  <th>Options</th>
                </tr>
              </thead>
              <tbody>
                {error ? ( // If there's an error
                  <tr>
                    <td colSpan="6" className="text-danger text-center">
                      {error} {/* Show the error inside the table */}
                    </td>
                  </tr>
                ) : franchises.length === 0 ? ( // If no data
                  <tr>
                    <td colSpan="6">No jillas available.</td>
                  </tr>
                ) : ( // If there is data
                  currentFranchise.map(franchise => (
                    <tr key={franchise.arthik_sakha_id}>
                      <td>{franchise.arthik_sakha_id}</td>
                      <td>{franchise.search_tag}</td>
                      <td>{franchise.arthik_sakha}</td>
                      <td>{franchise.jilla_name}</td>
                      <td>
                        <div className="d-flex justify-content-center">
                          {/* <button
                            type="button"
                            className="btn btn-warning btn-ico newicobtn "
                            onClick={() => handleEditClick(franchise.franchise_id)}
                          >
                            <i className="bx bxs-edit icon"></i>
                          </button> */}



                          <button type="button" className="btn btn-info btn-ico newicobtn newviewbtn" onClick={() => handleViewClick(franchise.arthik_sakha_id)}>
                            Sthans
                          </button>


                          <button type="button" className="btn btn-primary newicobtn newviewbtn" onClick={() => handleActiveUsersClick(franchise.arthik_sakha_id)}>
                            Active users
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>

            </table>
          </div>

          {totalPages > 1 && (
            <div className="pagination">
              <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>Previous</button>
              {Array.from({ length: totalPages }, (_, index) => (
                <button
                  key={index}
                  onClick={() => handlePageChange(index + 1)}
                  disabled={currentPage === index + 1}
                >
                  {index + 1}
                </button>
              ))}
              <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>Next</button>
            </div>
          )}
        </div>
      </section>
      <TopBar />
      {/* </Container> */}
    </>
  );
};

export default ListArthikSakhas;
